import Detail from './detail';
import { useProductStore } from './ProductProvider';
import EfScrollAni from '@/efscrollani';
import styles from './index.module.scss';
import { useRouter } from 'next/router';

export default function ExampleProductA() {
    const { pageStatus } = useProductStore();

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    return (
        <div className={styles.page}>
            <Detail />
        </div>
    );
}
